import { render, staticRenderFns } from "./Box.vue?vue&type=template&id=1da71f4f&scoped=true"
var script = {}
import style0 from "./Box.vue?vue&type=style&index=0&id=1da71f4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da71f4f",
  null
  
)

export default component.exports